import events from "../events/EventsObservable";
import AddResult from "../connect/result/AddResult";
import SystemConfig, {CONFIG_PARAMS, MODES} from "../system/SystemConfig";
import {GAME_EVENTS} from "./gameEvents";
import Connect from "../connect/Connect";

class GameFreespins {

    private _gameset: any;
    private _config: SystemConfig;
    private _connect: Connect;

    private _roundIndex: number;
    private _addResult: AddResult;
    private _inFreeSpins: boolean;

    private _freeSpinNumber: number;
    private _freeSpinNumberTotal: number;
    private _skipping: boolean;
    private _keepUpdating: boolean;
    private _keepUpdateTimeout: number;

    private _unfinishedData: any = undefined;

    constructor(config: SystemConfig, connect: Connect) {
        this._gameset = config.gameset;
        this._config = config;
        this._connect = connect;


        this._roundIndex = -1;

        this._addResult = null;

        this._inFreeSpins = false;

        // this._win = 0;

        /**
         * @type {number}
         * @private
         */
        this._freeSpinNumber = 0;
        this._freeSpinNumberTotal = 0;

        this._skipping = false;
        this._keepUpdating = false;

        this._keepUpdateTimeout = null;

        events.subscribe(GAME_EVENTS.GAME_ENTER_FREESPINS, this);
        events.subscribe(GAME_EVENTS.GAME_END_ROUND_FREESPINS, this);
    }

    notify(eventName) {

        switch(eventName) {
            case GAME_EVENTS.GAME_ENTER_FREESPINS:
                this._refreshStart();
                break;

            case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
                this._refreshStop();
                break;
        }

    }

    isSkipping() {
        return this._skipping;
    }

    isFreespinsAutorun() {
        return this._gameset.game.freespins && this._gameset.game.freespins.autostart;
    }

    /** @returns {boolean} */
    isInFreeSpins() {
        return this._inFreeSpins;
    }

    setInFreeSpins(bool) {
        this._inFreeSpins = bool;
    }

    getRoundIndex() {
        return this._roundIndex;
    }

    getRoundNumber() {
        return this._roundIndex + 1;
    }

    setRoundIndex(idx) {
        if(idx != null) {
            this._roundIndex = idx;
        }
        else {
            debugger;
        }
    }

    incRoundIndex() {
        this._roundIndex++;
    }

    setFreeSpinNumber(val) {
        this._freeSpinNumber = val;
    }

    getFreeSpinNumber() {
        return this._freeSpinNumber;
    }

    _initFreeSpinNumber() {

        let result = this._addResult;
        let num = this._freeSpinNumberTotal;

        if(this._roundIndex > -1) {
            let res = result.getFreeSpinResult(this._roundIndex);
            if(res)  {
                num = res.getFreeSpinsNumber();
            }
        } else {
            num = result.getFreeSpinsNumber();
        }

        // console.log(num);
        // debugger;

        this.setFreeSpinNumber(num);
    }

    /**
     * @param {AddResult} result
     * @private
     */
    _initResult(result) {
        this._addResult = result;
    }

    getWin() {
        return this.getRoundWin(this._roundIndex);
    }

    getRoundWin(roundIndex) {
        if(roundIndex < 0) {
            return this._addResult.getWin();
        }

        if(roundIndex == 0) {
            return this.getResultWin(roundIndex) - this._addResult.getWin();
        }

        return this.getResultWin(roundIndex) - this.getResultWin(roundIndex - 1);
    }

    /**
     * Returns result win (sum of all results up to index)
     * @param {number} index
     * @return {number}
     */
    getResultWin(index = this._roundIndex) {

        let res = this.getResult(index);
        if(res) {
            return res.getWin();
        }

        return 0;
    }

    getRoundWinByLines(roundIndex = this._roundIndex, calcFunc?: Function) {

        let win = this._addResult.getLWTotalWin(calcFunc);

        for(let i = 0; i <= roundIndex; i++) {
            win += this.getResult(i).getLWTotalWin(calcFunc);
        }

        return win;
    }

    // /**
    //  *
    //  * @param {number} index
    //  * @return {number}
    //  */
    // getWinSumByLines(index = this._roundIndex) {
    //     let sum = 0;
    //     for(let i = 0; i <= index; i++) {
    //         sum += this.getRoundWin(i);
    //     }
    //     return sum;
    // }

    // /**
    //  * Returns win from lines win by round index
    //  * @param index
    //  * @return {number}
    //  */
    // getRoundWin(index = this._roundIndex) {
    //     let res = this.getResult(index);
    //
    //     if(res) {
    //         return res.getLWTotalWin();
    //     }
    //
    //     return 0;
    // }

    // setWin(val) {
    //     // this._win = val;
    // }

    getFreeSpinNumberTotal() {
        return this._freeSpinNumberTotal;
    }

    /**
     *
     * @param roundIndex
     * @return {undefined|AddResult}
     */
    getResult(roundIndex) {
        return this._addResult.getFreeSpinResult(roundIndex);
    }

    getActualResult() {
        return this.getResult(this.getRoundIndex());
    }

    getNextResult() {
        return this.getResult(this.getRoundIndex() + 1);
    }

    isLastRound() {

        return !this.getNextResult();

        // return !this.getActualResult();
    }

    /**
     * @param {AddResult} result
     */
    run(result) {

        this._initResult(result);

        if(!this.isInFreeSpins()) {
            this._start();
        }

        this._initFreeSpinNumber();
    }

    _start() {
        events.dispatch(GAME_EVENTS.GAME_ENTER_FREESPINS)
        this.setInFreeSpins(true);
        this.setRoundIndex(-1);
        this._freeSpinNumberTotal = this._addResult.getFreeSpinResults().length;

        if (this.getUnfinishedData()?.order !== undefined) {
            this._skipping = true;
            this._initFromUnfinishedData();
        }
    }

    _initFromUnfinishedData() {
        let data = this.getUnfinishedData();
        if (data && data.order) {
            this.setRoundIndex(data.order-1);
        }
    }

    onEndRound() {
        this._skipping = false;
    }

    end() {
        this._skipping = false;
        this.setInFreeSpins(false);
        this.setRoundIndex(-1);
        this.setFreeSpinNumber(0);
        this._freeSpinNumberTotal = 0;

        this._pureUnfinishedData();
    }

    _pureUnfinishedData() {
        this._unfinishedData = undefined;
    }

    _refreshStart() {
        if(!this._config.get(CONFIG_PARAMS.URL_BALANCE)) {
            console.warn("Balance URL not defined!");
            return;
        }

        if (this._config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
            return;
        }

        if(this._keepUpdating) {
            return;
        }

        this._keepUpdating = true;
        this._refreshLoop();
    }

    _refreshLoop() {

        if(!this._keepUpdating) {
            return;
        }

        this._keepUpdateTimeout = setTimeout(() => {

            if(!this._keepUpdating) {
                return;
            }

            try {
                this._connect.balance();
            } catch (e) {
                console.log(e);
            }

            this._refreshLoop();

        }, 5 /*getRandomInt(60, 120)*/ * 1000);

    }

    _refreshStop() {

        this._keepUpdating = false;
        clearTimeout(this._keepUpdateTimeout);
        this._keepUpdateTimeout = null;
    }

    setUnfinishedData(data) {
        this._unfinishedData = data;
    }

    getUnfinishedData(): any {
        return this._unfinishedData;
    }

    isStored(roundId = this._addResult.getRoundId()) {
        let data = this.getUnfinishedData();
        return (data && data.round_id == roundId && data.order != null && data.order-1 > -1);
    }
}


export default GameFreespins;